var MuiToggleButtonGroup = {
/* your custom class style overrides here */
};
export default MuiToggleButtonGroup;
//# sourceMappingURL=MuiToggleButtonGroup.js.map